define('areas/organizationmanager/commands/directloginmembercommand',["require", "exports", "services/trace", "services/httpclient"], function (require, exports, Trace, Http) {
    "use strict";
    var DirectLoginMemberCommand = (function () {
        function DirectLoginMemberCommand() {
        }
        DirectLoginMemberCommand.prototype.execute = function (member) {
            try {
                var httpClient = new Http.Channel();
                var action = "/api/networkmember/getdirectlogin";
                var query = "?memberId=" + member.id + "&isMagic=false";
                httpClient.getData(action + query, Http.ServiceTarget.portalApi).
                    then(function (data) {
                    window.open(data, "_blank");
                }).fail(function (error) {
                    Trace.traceError(error.responseJSON.Message, null, "organizationmanager:networkmembers", true);
                });
            }
            catch (exception) {
                Trace.traceError(exception, null, "organizationmanager:networkmembers", true);
            }
        };
        return DirectLoginMemberCommand;
    }());
    return DirectLoginMemberCommand;
});

